import { render, staticRenderFns } from "./ViewChangesHistory.vue?vue&type=template&id=2e128a9a&scoped=true&"
import script from "./ViewChangesHistory.vue?vue&type=script&lang=ts&"
export * from "./ViewChangesHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e128a9a",
  null
  
)

export default component.exports